import React, { useState, useLayoutEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { CustomTextFieldProp } from '@/components/common/CustomTextField';
import PageTitle from '@/components/common/PageTitle';
import HookFormControls from '@/components/common/HookFormControls';
import Phone from '@/types/Phone.type';
import PhoneService from '@/services/Phone.service';
import { FormProvider, useForm } from 'react-hook-form';
import { useSnackbar } from 'notistack';
import { Messages } from '@/common/constants';
import Loading from '@/components/common/Loading';
import CommonActionButton from '@/components/common/CommonActionButton';
import URL from '@/common/routes/Url';

const PhoneDetail: React.FC = () => {
  const pathParams = useParams<{ id: string }>();

  const inputs: Array<CustomTextFieldProp> = [
    {
      name: 'number',
      type: 'text',
      label: '電話番号*',
      rule: {
        required: '電話番号は必須項目です。',
        maxLength: {
          value: 15,
          message: '電話番号は15字以内で入力してください。',
        },
        /*pattern: {
          value: new RegExp('^0[0-9]{9,14}$'),
          message: '電話番号は0から始まる、10~15桁の数字で入力してください。',
        },*/
      },
    },
  ];

  const useFormMethods = useForm<Phone>({ shouldUnregister: false });
  const {
    handleSubmit,
    formState: { isSubmitting },
    reset,
  } = useFormMethods;
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);

  useLayoutEffect(() => {
    if (!pathParams.id) {
      setLoading(false);
      return;
    }
    PhoneService.get(pathParams.id)
      .then((response: { data: Phone }) => {
        reset(response.data);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        navigate(URL.phones);
        enqueueSnackbar(Messages.select.failure);
      });
  }, []);

  const onSubmit = async (values: Phone) => {
    try {
      console.log(values);
      if (pathParams.id) {
        await PhoneService.update(values, pathParams.id);
        enqueueSnackbar(Messages.update.success, { variant: 'info' });
      } else {
        await PhoneService.create(values);
        enqueueSnackbar(Messages.create.success, { variant: 'info' });
      }
      navigate(URL.phones);
    } catch (error: any) {
      enqueueSnackbar(error.response.data.message);
      return;
    }
  };

  if (loading) {
    return <Loading />;
  }
  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} md={8} lg={4}>
        <Box sx= {{ display: { xs: 'block', sm: 'none' } }}>
          <PageTitle>共有電話マスタ ー 編集</PageTitle>
        </Box>
        <Paper variant="outlined" sx={{ my: { xs: 0, md: 0 }, p: { xs: 2, md: 3 } }}>
          <FormProvider {...useFormMethods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={3}>
                {inputs.map((input, index) => (
                  <Grid item key={index} xs={12} md={12}>
                    <HookFormControls key={index} {...input} autoComplete="off" />
                  </Grid>
                ))}
                <Grid item xs={12} md={12}>
                  <CommonActionButton isSubmitting={isSubmitting} />
                </Grid>
              </Grid>
            </form>
          </FormProvider>
        </Paper>
      </Grid>
    </Grid>
  );
};
export default PhoneDetail;
